import { ProductProps } from '@customTypes/types';
import { sendMail } from '@services/mail';

const formTagsToIgnore: string[] = [
  'BUTTON',
];

const getDefaultKeysOrder = (form) => {
  return [...form.elements]
    .filter(field => !formTagsToIgnore.includes(field.tagName))
    .map(field => field.name);
};

export const getSortedFormFields = (
    form,
    namespace: string,
    subject: string,
    category: string = '',
    product?: ProductProps
  ) => {
  const keysOrder = getDefaultKeysOrder(form);
  const data: object = {};
  const formData = new Map();
  let countryCode: string;

  [...form.elements]
    .filter(field => !formTagsToIgnore.includes(field.tagName))
    .forEach(field => {
      const key = field.name;
      let value = field.value;

      if (key === 'countryCode') {
        countryCode = value;
        return;
      }

      if (key === 'supportHoursAcknowledgement') {
        return;
      }

      if (key === 'file') {
        value = field.files.length ? field.files[0] : "";
      }

      if (key === 'phone') {
        data[key] = countryCode ? `${countryCode} ${value}` : value;
      } else {
        data[key] = value;
      }
    });

  if (category !== '') {
    !keysOrder.includes('category') && keysOrder.unshift('category');
    data['category'] = category;
  }

  keysOrder.forEach(key => {
    if (!(key in data)) {
      return;
    }

    formData.set(key, data[key])
  });

  formData.set('namespace', namespace);
  formData.set('subject', subject);

  // added to send the same data from standalone and consolidated forms
  if (formData.has('helpWithInCons')) {
    formData.set('helpWith', data['helpWithInCons']);
    formData.delete('helpWithInCons');
  }

  if (product) {
    formData.set('productNumber', product.number);
    formData.set('productName', product.name);
    formData.set('productLineCode', product.lineCode);
    formData.set('productType', product.type);
  }

  formData.set('emptyLine', '');
  formData.set('formId', '');

  return formData;
};

export const handleFormSubmit = async (data, onSuccess, onError, onLoading) => {
  onLoading(true);

  try {
    const res = await sendMail(data);
    let status = res === 200;
    onLoading(false);

    if (status) {
      onSuccess(true);
    } else {
      onError(true);
    }
  } catch (err) {
    console.warn(err);
  }
};
